var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-jm",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 256 256L0 512zm512 0L256 256l256 256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "m0 0 256 256L512 0zm0 512 256-256 256 256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M512 0h-47.7L0 464.3V512h47.7L512 47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M0 0v47.7L464.3 512H512v-47.7L47.7 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJm);
export default __webpack_public_path__ + "static/media/jm.7d5811b1a304610d2cbc2648b82298ad.svg";
export { ForwardRef as ReactComponent };